import { FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";

@Component({
  selector: "app-refound-entry",
  templateUrl: "./refound-entry.component.html",
  styleUrls: ["./refound-entry.component.css"]
})
export class RefoundEntryComponent implements OnInit {
  form: FormGroup;
  errObject: any;
  param: any;
  errors = new Array();
  refoundCalc: any;

  constructor(
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RefoundEntryComponent>
  ) { }

  ngOnInit() {
    this.data.invoiceDeadLine="25/12/1398";
  }

  onClose() {
    this.dialogRef.close();
  }
}
